import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setStepperState} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET, RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import Tr from "../translations/Translations";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";

const DEMAND_PLAN_REALIZATIONS_RESOURCE_ID = 'demandPlanRealizations';

const getRealizations = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.DEMAND_PLAN_REALIZATION(demandId));
    reduxStore.dispatch(setResource(DEMAND_PLAN_REALIZATIONS_RESOURCE_ID, resp))
}

const saveRealizations = async (demandId, values) => {

    const valuesTouched = values.filter(x => x._touched).map(x => {
        const y = {...x};
        delete y._touched
        return y;
    })

    let resp;
    if (valuesTouched.length > 0) {
        try {
            resp = await RestRequestPOST(Endpoints.DEMAND_PLAN_REALIZATION(demandId), {list: valuesTouched});
        } catch (e) {
            console.error(e)
        }
    }

    if (!resp) {
        reduxStore.dispatch(setStepperState());
    } else if(resp.success) {
        reduxStore.dispatch(setSaveStatusDialog());
        await validateSection(DemandValidation.DEMAND_PLAN_REALIZATION, demandId, false);
        reduxStore.dispatch(setStepperState());
    } else {
        if (resp && Array.isArray(resp.errors) && resp.errors.length > 0) {
            reduxStore.dispatch(setSaveStatusError(resp.errors[0]));
        } else {
            reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
        }
    }


}


const validate = async (demandId) => {
    return await RestRequestGET(Endpoints.DEMAND_PLAN_REALIZATION_VALIDATE(demandId));
}

const clearResources = () => {
    reduxStore.dispatch(clearResource(DEMAND_PLAN_REALIZATIONS_RESOURCE_ID));
}

export default {
    getRealizations,
    saveRealizations,
    validate,
    clearResources,
    DEMAND_PLAN_REALIZATIONS_RESOURCE_ID
}